module.exports = __webpack_public_path__ + "img/yszc-sj-yy.b5798c31.png";